import PolicyPage, { Section } from './PolicyPage'
import { PRODUCT_NAME } from '../content/provenance'

/**
 * The privacy statement.
 *
 * **Written to be true of the template as it ships**, rather than carrying
 * instructions to the reader. These routes are linked from the footer, so
 * whatever is here is published; authoring notes belong in comments like this
 * one and in `docs/security/11-privacy-impact-assessment.md`.
 *
 * A project replaces each section as it starts handling information about
 * people. Until it does, what follows is accurate: the template collects
 * nothing.
 */
export default function PrivacyPage() {
  return (
    <PolicyPage
      title="Privacy"
      intro={`What ${PRODUCT_NAME} collects, why, and how long it is kept.`}
    >
      <Section id="collect" heading="What is collected">
        <p>
          {PRODUCT_NAME} asks for no account and sets no tracking cookie.
        </p>
        <p>
          Requests are recorded in access logs, which hold the requesting IP
          address, the browser&apos;s user agent, the path, a timestamp, and a
          response status.
        </p>
      </Section>

      <Section id="use" heading="How it is used">
        <p>
          Access logs are used to keep the service available and to investigate
          faults and security events.
        </p>
      </Section>

      <Section id="retention" heading="How long it is kept">
        <p>
          Logs are kept for their scheduled term and then removed.
        </p>
      </Section>

      <Section id="sharing" heading="Who it is shared with">
        <p>
          The cloud provider hosting the service, in the course of operating it.
        </p>
      </Section>

      <Section id="access" heading="Access and correction">
        <p>
          Enquiries go to the operator, reachable through the credit in the
          footer.
        </p>
      </Section>
    </PolicyPage>
  )
}
